export default "__VITE_PUBLIC_ASSET__e261b73a__"